import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

export interface ISubscribeWallet {
    walletAddress: string;
    endpoint: string;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationsFetcherService {
    private rootURL = '/api';
    constructor(private http: HttpClient) {
    }

    async subscribeAll(credential: PushSubscriptionJSON): Promise<void> {
        const url = `${this.rootURL}/notifications/subscribe-all`;
        const body = {
            ...credential,
        };
        await this.http.post(url, body).toPromise();
    }

    async subscribe(credential: PushSubscriptionJSON, walletsAddress: string[]): Promise<void> {
        const url = `${this.rootURL}/notifications/subscribe`;
        const body = {
            credential,
            walletsAddress,
        };
        await this.http.post(url, body).toPromise();
    }

    async subscribeWallets(wallets: ISubscribeWallet[]): Promise<void> {
        const url = `${this.rootURL}/notifications/subscribe-wallets`;
        await this.http.post(url, wallets).toPromise();
    }

    async unsubscribe(endpoint): Promise<void> {
        const url = `${this.rootURL}/notifications/unsubscribe`;
        const body = {
            endpoint,
        };
        await this.http.delete(url, { body }).toPromise().catch(e => {
            console.error(e);
        });
    }

    async unsubscribeWallets(wallets: ISubscribeWallet[]): Promise<void> {
        const url = `${this.rootURL}/notifications/unsubscribe-wallets`;
        await this.http.delete(url, { body: wallets }).toPromise().catch(e => {
            console.error(e);
        });
    }

    async unsubscribeWalletsAll(cryptoWalletID: string): Promise<void> {
        const url = `${this.rootURL}/notifications/unsubscribe-wallets-all`;
        const body = {
            cryptoWalletID
        };
        await this.http.delete(url, { body }).toPromise().catch(e => {
            console.error(e);
        });
    }

    async unsubscribeAll(): Promise<void> {
        const url = `${this.rootURL}/notifications/unsubscribe-all`;
        await this.http.delete(url).toPromise().catch(e => {
            console.error(e);
        });
    }

    async checkSubscribe(endpoint: string): Promise<boolean> {
        const url = `${this.rootURL}/notifications/check-endpoint?endpoint=${endpoint}`;
        const body = {
            endpoint,
        };
        return await this.http.post<boolean>(url, body).toPromise();
    }

    async checkSubscribeAll(): Promise<boolean> {
        const url = `${this.rootURL}/notifications/check-endpoint-all`;
        return await this.http.get<boolean>(url).toPromise();
    }

    async checkSubscribeForWallet(walletAddress: string, endpoint: string): Promise<boolean> {
        const url = `${this.rootURL}/notifications/check-endpoint-for-wallet`;
        const body = {
            walletAddress,
            endpoint
        };
        return await this.http.post<boolean>(url, body).toPromise();
    }

    async checkSubscribeWallet(walletID: string): Promise<boolean> {
        const url = `${this.rootURL}/notifications/check-wallet?&walletID=${walletID}`;
        return await this.http.get<boolean>(url).toPromise();
    }
}
